import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Alert } from "react-bootstrap";
import moment from "moment";
import AdminPanel from "../AdminPanel/AdminPanel";
import CustomerPanel from "../CustomerPanel/CustomerPanel";
import UserPanel from "../UserPanel/UserPanel";
import LicenseExpirationWarningContainer from "../LicenseExpirationWarning/LicenseExpirationWarning";
import LicensesInUsePanel from "../LicensesInUsePanel/LicensesInUsePanel";
import LogsPanel from "../LogsPanel/LogsPanel";
import PasswordExpirationTime from "../../Stores/DataStore/Enums/PasswordExpirationTime";

class HomePanel extends Component {
  render() {
    const { stores } = this.props;
    const user = stores.currentUser.user;
    const customer = stores.currentUser.customer;
    const userPanel = <UserPanel />;

    let customerPanel = null;
    if (user && !user.isAdmin) {
      if (customer) {
        customerPanel = <CustomerPanel />;
      }
    }

    let adminPanel = null;
    if (user && user.isAdmin) {
      adminPanel = <AdminPanel />;
    }

    let logsPanel = null;
    if (user && (user.isPrimaryUser || user.isAdmin)) {
      logsPanel = <LogsPanel customerId={user.CustomerId} />;
    }

    let licensesAboutToExpire = null;
    let licensesInUsePanel = null;
    if (customer) {
      licensesAboutToExpire = <LicenseExpirationWarningContainer customerId={customer.Id} />;
      licensesInUsePanel = <LicensesInUsePanel stores={stores} />;
    }

    let passwordExpiry = null;
    // If there is a user and the password can expire
    if (user && customer.PasswordExpirationTime !== new PasswordExpirationTime().NEVER.Key) {
      // PasswordExpirationTime holds the passwordExpirationTime as a key/Name pair where the name is a moment duration object
      const timeAddition = new PasswordExpirationTime().findByKey(customer.PasswordExpirationTime);
      const expiryDate = moment(user.PasswordUpdated).add(timeAddition.Name);

      if (expiryDate < moment().add(1, "M")) {
        passwordExpiry = (
          <Alert>
            <p>Your password is going to expire on {moment(expiryDate).format("L")}</p>
          </Alert>
        );
      }
    }

    return (
      <div>
        <div className="row">
          <h1>Home</h1>
        </div>

        <div className="row">{licensesAboutToExpire}</div>

        <div className="row">{passwordExpiry}</div>

        <div className="row">
          {userPanel}
          {customerPanel}
          {adminPanel}
          {licensesInUsePanel}
          {logsPanel}
        </div>
      </div>
    );
  }
}

export default inject("stores")(observer(HomePanel));



// WEBPACK FOOTER //
// ./src/Components/HomePanel/HomePanel.js